import Color from '../services/color.service';

const ColorMixin = {
  methods: {
    getColor(macro) {
      return Color.getColorForMacro(macro);
    }
  }
};
export default ColorMixin;
